export default "__VITE_ASSET__CyY5Cakp__"